module.exports = __webpack_public_path__ + "img/file_download.e2dec7cc.svg";